import React from "react";
import { PostType } from "@components/severalbrands/gqlQueries";
import { getMainTitlesNavigationFromBody } from "@components/severalbrands/utils";
import SideWidget from "./sideWidget";
import MainContent from "./mainContent";
import { replacePlaceholders } from "@lib/sharedUtils";
export default function SecondSection({
    post,
    allPosts,
}: {
    post: PostType;
    allPosts: PostType[];
}) {
    const category = post?.category?.label ?? post?.category?.name;

    const finalPosts = allPosts
        .filter((blog) => blog.id !== post.id)
        .slice(0, 4);
    return (
        <section className="lg:mt-20 mt-5 lg:mb-48 mb-24 ">
            <div className=" flex flex-col lg:flex-row  3xl:gap-[140px]  lg:gap-[100px] gap-[62px] ">
                <MainContent post={post} />
                <SideWidget
                    titlesList={getMainTitlesNavigationFromBody(
                        replacePlaceholders(post.body, {
                            category,
                        }),
                    )}
                    allPosts={finalPosts}
                />
            </div>
        </section>
    );
}
